<template>
  <section class="speakers-section">
    <v-container>
      <!-- Insights Section -->
      <div class="insights-header">
        <h2 class="section-heading">
          2026 оны Боловсролын салбарын шилдэг олон улсын арга xэмжээ,
          үзэсгэлэнд таныг уръя
        </h2>
        <p style="width: 80%; margin-left: auto; margin-right: auto">
          Бид олон улсын шилдэг боловсролын салбарын хурал, арга хэмжээ болон
          үзэсгэлэн xудалдааг судалж, боловсролын байгууллагад хамгийн
          хэрэгцээтэй, үр өгөөжтэй, олон улсад xүлээн зөвшөөрөгдсөн арга xэмжээ,
          үзэсгэлэн xудалдааг танд зориулж сонгон авлаа.
        </p>
      </div>

      <!-- Image Gallery Grid -->
      <div class="insights-gallery">
        <!-- Image 1: Top Left -->
        <div class="gallery-item img-1">
          <v-img
            src="/assets/b1.png"
            alt="Conference Audience"
            loading="lazy"
            height="100%"
            cover
          />
        </div>

        <!-- Image 2: Top Middle -->
        <div class="gallery-item img-2">
          <v-img
            src="https://www.globalaishow.com/wp-content/uploads/2025/01/speaker-3.webp"
            alt="Panel Discussion"
            class="gallery-img mt-n3"
            loading="lazy"
            height="120%"
            cover
          />
        </div>

        <!-- Image 3: Right Tall (spans 2 rows) -->
        <div class="gallery-item img-3">
          <v-img
            src="assets/b4.png"
            alt="Speaker Portrait"
            class="gallery-img"
            loading="lazy"
            height="100%"
            cover
          />
        </div>

        <!-- Image 4: Middle Wide (spans 2 columns) -->
        <div class="gallery-item img-4">
          <v-img
            src="https://www.globalaishow.com/wp-content/uploads/2025/01/Frame-237673-4.webp"
            alt="INTERNATIONAL EDU TRAVEL Stage"
            class="gallery-img"
            loading="lazy"
          />
        </div>

        <!-- Image 5: Bottom Left -->
        <div class="gallery-item img-5">
          <v-img
            src="/assets/b5.png"
            alt="Conference Event"
            class="gallery-img"
            loading="lazy"
          />
        </div>

        <!-- Image 6: Bottom Middle -->
        <div class="gallery-item img-6">
          <v-img
            src="https://www.globalaishow.com/wp-content/uploads/2025/01/Frame-237676-2.webp"
            alt="Presentation Screen"
            class="gallery-img mt-n3"
            loading="lazy"
            cover
            height="120%"
          />
        </div>

        <!-- Image 7: Bottom Right -->
        <div class="gallery-item img-7">
          <v-img
            src="https://www.globalaishow.com/wp-content/uploads/2025/01/Frame-237677-2.webp"
            alt="Panel Session"
            class="gallery-img mt-n3"
            loading="lazy"
            height="120%"
            cover
          />
        </div>
      </div>

      <div class="insights-header mt-10">
        <p style="width: 80%; margin-left: auto; margin-right: auto">
          Дэлxийн шилдэг арга xэмжээнд оролцсоноор олон улсын боловсролын чиг
          xандлага, теxнологийн xөгжлийг газар дээр нь танилцаx боломж нээгдэж,
          таны арга туршлага, алсын xараx тэлэx болно.
        </p>
      </div>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "SpeakersSection",
  components: {},
  data() {
    return {
      dialog: false,
      selectedSpeaker: null,
      speakers: [
        {
          name: "Honourable Nate Glubish",
          title: "Minister of Technology and Innovation",
          company: "Government of Alberta, Canada",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2025/10/Honourable-Nate-Glubish.webp",
          bio: `<p>Honourable Nate Glubish was first elected as a Member of the Legislative Assembly for Strathcona-Sherwood Park on April 16, 2019 and re-elected on May 29, 2023.</p>
                <p>Nate was sworn in as Minister of Service Alberta in 2019 and led the Government of Alberta's efforts to apply technology to deliver better, faster, and smarter services to Albertans.</p>
                <p>In 2022, he was sworn in to lead the newly created Ministry of Technology and Innovation, focusing on attracting investment in Alberta's technology sector and ensuring every Albertan has access to reliable high-speed internet.</p>`,
        },
        {
          name: "Pujya Brahmavihari Swami",
          title: "Spiritual Leader",
          company: "Head of BAPS Hindu Mandir, Abu Dhabi",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2024/12/Pujya-Brahmavihari-Swami.webp",
          bio: `<p>Pujya Brahmavihari Swami (Swami Brahmaviharidas) leads the BAPS Hindu Mandir project in Abu Dhabi, the first traditional stone temple in the Middle East, serving as a powerful symbol of cultural harmony and interfaith collaboration.</p>
                <p>He is responsible for international relations at BAPS, steering the organization's global outreach through devotional, humanitarian, and spiritual initiatives. The temple has become a beacon of peace and unity, frequented by leaders from both the UAE and India.</p>`,
        },
        {
          name: "Professor Shafi Ahmed",
          title: "Surgeon, Futurist, Humanitarian, CEO",
          company: "Medical Realities",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2024/11/professor-shafi-ahmed.webp",
          bio: "<p>Professor Shafi Ahmed is a pioneering surgeon, futurist, and humanitarian who is revolutionizing medical education and healthcare through immersive technologies like VR and AR.</p>",
        },
        {
          name: "John Nosta",
          title: "Leading Innovation Theorist in Technology, AI & Medicine",
          company: "Founder of NOSTALAB",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2024/12/john-nosta.webp",
          bio: `<p>John Nosta is an intellectual journey guide at the nexus of technology, artificial intelligence, and humanity. With a commanding presence and rich insights, he captivates audiences by transforming complex intersections of AI, machine learning, and medical science into actionable wisdom.</p>
                <p>He navigates the exhilarating path of exponential growth in AI, illustrating how advancements enhance professional and personal lives while fundamentally reshaping our approach to living.</p>`,
        },
        {
          name: "Janet Adams",
          title: "COO / Board Director",
          company: "SingularityNET / ASI",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2024/12/Janet-Adams-1.webp",
          bio: `<p>A disruptive tech advocate and decentralised AI expert with published works on Ethics and Regulation of AI. Janet's leadership at SingularityNET includes responsibility for technology, operations, marketing, strategic partnerships, business development, and Deep Funding.</p>
                <p>She leads AI and Blockchain initiatives across robotics, biotech, gaming, metaverse, media, DeFi, and music. She co-founded Cogito Protocol and is committed to a positive Singularity for all of humanity.</p>`,
        },
        {
          name: "Jeanie Fang",
          title: "Director Data & AI",
          company: "Crunchbase",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2024/11/Jeanie-Fang.webp",
          bio: `<p>Jeanie leads the Data Management organization at Crunchbase, driving the mission to democratize access to opportunity by delivering data that connects innovators. Her team is responsible for all data featured on Crunchbase's platform.</p>
                <p>An avid traveler having visited over 80 countries, she is also a licensed realtor passionate about real estate and helping others with their real estate goals.</p>`,
        },
        {
          name: "Georges De Moura",
          title: "Group Vice President and CISO",
          company: "EDGE Group",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2024/09/Georges-De-Moura.webp",
          bio: `<p>Georges De Moura serves as Vice President of Information Security and CISO at EDGE Group, an Advanced Technology and Defence international conglomerate headquartered in Abu Dhabi, UAE.</p>
                <p>He has 20+ years' experience in IT and cybersecurity across aerospace, defence, and aviation. Prior roles include the World Economic Forum's Centre for Cybersecurity and Etihad Aviation Group global CISO.</p>`,
        },
        {
          name: "H. E. Dr. Mohamed Al Kuwaiti",
          title: "Head of Cyber Security Council",
          company: "UAE Government",
          image:
            "https://www.globalaishow.com/wp-content/uploads/2024/07/mohammed-Al-kuwaiti.webp",
          bio: `<p>Dr. Al Kuwaiti was appointed by the Cabinet as Head of Cyber Security for the UAE Government in 2020. He serves as Chairman of the UAE Cyber Security Council and Managing Director of the National Data Centre.</p>
                <p>Under his leadership, the UAE advanced 42 positions in the ITU Global Cybersecurity Index to 5th place globally. He led UAE to multiple Guinness World Records in cybersecurity and established key public-private partnerships.</p>`,
        },
      ],
    };
  },
  methods: {
    openSpeakerDialog(speaker) {
      this.selectedSpeaker = speaker;
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
.speakers-section {
  background: white;
  padding: 80px 0;
  padding-bottom: 0px !important;
  position: relative;
  overflow: hidden;
}

/* Insights Header */
.insights-header {
  text-align: center;
  margin-bottom: 60px;
}

.section-heading {
  font-size: 48px;
  font-weight: 700;
  margin-bottom: 20px;
  line-height: 1.2;
  color: #030068;
}

.gradient-text {
  background: linear-gradient(90deg, #00f5ff 0%, #ff00ff 50%, #00f5ff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Insights Gallery */
.insights-gallery {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, 280px);
  gap: 12px;
}

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.gallery-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.gallery-img {
  height: 100%;
  display: block;
  transition: transform 0.3s ease;
}

.gallery-item:hover .gallery-img {
  transform: scale(1.05);
}

/* Desktop Grid Layout */
/* Image 1: Top Left */
.img-1 {
  grid-column: 1 / 2;
  grid-row: 1 / 2;
}

/* Image 2: Top Middle */
.img-2 {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

/* Image 3: Right Tall (spans rows 1-2) */
.img-3 {
  grid-column: 3 / 4;
  grid-row: 1 / 3;
}

/* Image 4: Middle Wide (spans columns 1-2) */
.img-4 {
  grid-column: 1 / 3;
  grid-row: 2 / 3;
}

/* Image 5: Bottom Left */
.img-5 {
  grid-column: 1 / 2;
  grid-row: 3 / 4;
}

/* Image 6: Bottom Middle */
.img-6 {
  grid-column: 2 / 3;
  grid-row: 3 / 4;
}

/* Image 7: Bottom Right */
.img-7 {
  grid-column: 3 / 4;
  grid-row: 3 / 4;
}

/* Speakers Header */
.speakers-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 60px;
  flex-wrap: wrap;
  gap: 20px;
}

/* Speakers Grid */
.speakers-grid {
  margin-top: 40px;
}

.speaker-card {
  background: #ffffff !important;
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e0e0e0;
}

.speaker-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important;
  border-color: #7c3aed;
}

.speaker-image-wrapper {
  position: relative;
  overflow: hidden;
  height: 320px;
}

.speaker-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.speaker-card:hover .speaker-image {
  transform: scale(1.05);
}

.speaker-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.speaker-card:hover .speaker-overlay {
  opacity: 1;
}

.speaker-info {
  padding: 24px !important;
  text-align: center;
}

.speaker-name {
  font-size: 20px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 8px;
  line-height: 1.3;
}

.speaker-title {
  font-size: 14px;
  color: #666666;
  margin-bottom: 4px;
  line-height: 1.4;
}

.speaker-company {
  font-size: 13px;
  color: #7c3aed;
  font-weight: 500;
  margin-top: 4px;
}

/* Dialog Styles */
.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  max-height: 600px;
}

.dialog-content {
  padding: 40px !important;
}

.dialog-name {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
  color: #1a1a1a;
}

.dialog-title {
  font-size: 16px;
  color: #666;
  margin-bottom: 6px;
  font-weight: 500;
}

.dialog-company {
  font-size: 15px;
  color: #7c3aed;
  font-weight: 600;
  margin-bottom: 20px;
}

.dialog-bio {
  font-size: 14px;
  line-height: 1.8;
  color: #444;
}

.dialog-bio p {
  margin-bottom: 16px;
}

/* Responsive Design */
@media (max-width: 960px) {
  .speakers-section {
    padding: 60px 0;
  }

  .section-heading {
    font-size: 32px;
    line-height: 1.3;
  }

  /* Tablet Gallery - 2 Column Layout */
  .insights-gallery {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(5, 240px);
    gap: 10px;
    margin-bottom: 60px;
  }

  .img-1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }

  .img-2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
  }

  .img-3 {
    grid-column: 1 / 2;
    grid-row: 2 / 3;
  }

  .img-4 {
    grid-column: 2 / 3;
    grid-row: 2 / 3;
  }

  .img-5 {
    grid-column: 1 / 2;
    grid-row: 3 / 4;
  }

  .img-6 {
    grid-column: 2 / 3;
    grid-row: 3 / 4;
  }

  .img-7 {
    grid-column: 1 / 3;
    grid-row: 4 / 5;
  }

  .speakers-header {
    justify-content: center;
    text-align: center;
  }

  .dialog-content {
    padding: 24px !important;
  }

  .dialog-name {
    font-size: 24px;
  }
}

@media (max-width: 600px) {
  .speakers-section {
    padding: 50px 0;
  }

  .section-heading {
    font-size: 24px;
    line-height: 1.4;
    padding: 0 15px;
  }

  /* Mobile Gallery - Single Column Layout */
  .insights-gallery {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    gap: 12px;
    margin-bottom: 50px;
    padding: 0 10px;
  }

  .gallery-item {
    height: 220px;
    border-radius: 10px;
  }

  /* Reset all grid positions for mobile */
  .img-1,
  .img-2,
  .img-3,
  .img-4,
  .img-5,
  .img-6,
  .img-7 {
    grid-column: 1 / 2;
    grid-row: auto;
  }

  /* Featured images taller */
  .img-3,
  .img-4 {
    height: 260px;
  }

  .insights-header,
  .speakers-header {
    margin-bottom: 35px;
  }

  .speaker-image-wrapper {
    height: 250px;
  }

  .speaker-info {
    padding: 16px !important;
  }

  .speaker-name {
    font-size: 17px;
  }

  .speaker-title {
    font-size: 12px;
  }

  .speaker-company {
    font-size: 12px;
  }

  .dialog-content {
    padding: 18px !important;
  }

  .dialog-name {
    font-size: 20px;
  }

  .dialog-title,
  .dialog-company {
    font-size: 13px;
  }

  .dialog-bio {
    font-size: 12px;
    line-height: 1.7;
  }
}

@media (max-width: 480px) {
  .section-heading {
    font-size: 22px;
    padding: 0 10px;
  }

  .insights-gallery {
    gap: 10px;
    padding: 0 8px;
  }

  .gallery-item {
    height: 200px;
    border-radius: 8px;
  }

  .img-3,
  .img-4 {
    height: 240px;
  }
}

@media (max-width: 400px) {
  .section-heading {
    font-size: 20px;
  }

  .insights-gallery {
    gap: 8px;
  }

  .gallery-item {
    height: 180px;
  }

  .img-3,
  .img-4 {
    height: 220px;
  }

  .speaker-image-wrapper {
    height: 220px;
  }

  .speaker-name {
    font-size: 16px;
  }
}
</style>
